/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';

import ComplaintARModalController from '../../Modals/ActionRequiredModals/ComplaintARModal/ComplaintARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}

const Complaint = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});
  const [historyData, setHistoryData] = useState<any>({});

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const getComplaintHistoryCall = (empId: any, companyId: any, deptId: any) => {
    actionRequiredService
      .getComplaintHistory(empId, deptId, companyId)
      .then((result) => {
        setHistoryData(result?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTransferView = (complaint: any) => {
    setFullData(complaint);

    getComplaintHistoryCall(
      complaint.emp_id,
      complaint.company_id,
      complaint.department_id,
    );
  };

  const tableColumns: any = [
    {
      field: 'appliedOn',
      headerName: trans('Applied On'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.appliedOn}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'complaintBy',
      headerName: trans('Complaint By'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.complaintBy}
            picture={params?.row?.complaintByPic}
          />
        );
      },
    },
    {
      field: 'complaintTo',
      headerName: trans('Complaint To'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params?.row?.complaintTo}
            picture={params?.row?.complaintToPic}
          />
        );
      },
    },
    {
      field: 'description',
      headerName: trans('Description'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleTransferView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      complaintBy: `${data?.complaint_by_first_name} ${data?.complaint_by_last_name}`,
      complaintByPic: data?.profile_pic,
      complaintTo: `${data?.first_name} ${data?.last_name}`,
      complaintToPic: data?.for_profile_pic,
      appliedOn: data?.complaint_date,
      description: data?.description,
      fullData: data,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          localeText={isRTL ? arabicDataGrid : undefined}
          disableColumnMenu
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <ComplaintARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          historyData={historyData}
          fullData={fullData}
        />
      )}
    </>
  );
};

export default Complaint;
